import React from 'react';
import { Section, ProfileImage, Heading, Paragraph, Button, SocialMediaIcons, SocialMediaIcon } from './AboutStyle';
import HeroImage from '../../images/HeroImage.jpg';

const About = () => {
  return (
    <Section id="about">
      <ProfileImage
        src={HeroImage}
        alt="Kiruthiga Krishna Moorthy"
      />

      <Heading>About Me</Heading>
      <Paragraph>
        Hi! I'm <strong>Kiruthiga Krishna Moorthy</strong> from Chennai — a passionate backend developer and aspiring data analyst. I love building real-world solutions with Python, Django, and SQL.
      </Paragraph>
      <Paragraph>
        My journey so far includes projects like a complete <strong>Banking Management System</strong>, a <strong>Personal Expenses Tracker</strong>, and a <strong>Zomato Backend clone Simulation</strong>. I'm always ready to learn, grow, and deliver high-quality work as part of a dynamic team.
      </Paragraph>
      <SocialMediaIcons>
        <SocialMediaIcon href="https://github.com/kiruthiga-krishnamoorthy" target="_blank" rel="noopener noreferrer">GitHub</SocialMediaIcon>
        <SocialMediaIcon href="https://www.linkedin.com/in/kiruthiga-krishna-moorthy-75a8332a7" target="_blank" rel="noopener noreferrer">LinkedIn</SocialMediaIcon>
      </SocialMediaIcons>
      <Button
        href="https://drive.google.com/file/d/1B5R-vb5OWJIFixJdXOWXakbx6RNe6jgb/view?usp=drivesdk"
        target="_blank"
      >
        Download Resume
      </Button>
    </Section>
  );
};

export default About;
